export default {
  b_cancel: 'Kapat',
  b_save: 'Kaydet',
};
